// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PYO2","col":"styles_col__3Ijxu"};